import { useQueryClient } from '@tanstack/react-query';
import { useCommerceAPI } from '~/features/commerce-api/contexts';

type Props = {
    email?: string;
    phone?: string;
};

export const useLookupCustomer = () => {
    const queryClient = useQueryClient();
    const commerceApi = useCommerceAPI();

    const loopupCustomer = async ({ email, phone }: Props) => {
        return await queryClient.fetchQuery({
            queryKey: ['carriers', email, phone],
            queryFn: () =>
                commerceApi.shopperLookup?.lookupCustomer({
                    body: { email, phone },
                }),
        });
    };

    return { loopupCustomer };
};
